export default class MaskRemover {
  public static removeMask(value: string): string {
    return value.replace(/\D/g, ''); // Remove todos os caracteres não numéricos
  }
}
